import * as React from 'react';

export const BreakpointContext = React.createContext();

export const defaultBreakpoints = {
  xs: 0,
  sm: 600,
  ss: 701,
  smm: 821,
  ll: 900,
  md: 951,
  lg: 1281,
  xl: 1440,
};

const Breakpoints = ({ breakpoints = defaultBreakpoints, children }) => (
  <BreakpointContext.Provider value={breakpoints}>{children}</BreakpointContext.Provider>
);

export default Breakpoints;
